import { createNotification } from "../../../../../app/state/notificationSlice/slice";
import { getNotificationConfig } from "../../../../../app/state/notificationSlice/utils/getNotificationConfig";
import { getError } from "../../../../lib/getError";
import { appListenerMiddleware } from "../../appListenerMiddleware";

export function appNotificationListener() {
  appListenerMiddleware.startListening({
    predicate: (action) =>
      action.type.endsWith("/rejected") || action.type.endsWith("/fulfilled"),
    effect: (action, listenerApi) => {
      const config = getNotificationConfig(action.type);
      let notification;
      const { payload, error, type } = action;
      if (type.endsWith("/rejected")) {
        if ((action.meta as { aborted?: boolean })?.aborted) return;
        const errorMessage =
          typeof payload === "string" ? payload : getError(error);
        if (errorMessage && errorMessage !== "Request was canceled") {
          notification = createNotification(
            "error",
            errorMessage,
            5000,
            "Error",
          );
        }
      } else if (type.endsWith("/fulfilled")) {
        if (!config) return;
        const successConfig = config.success;
        if (successConfig) {
          const message =
            typeof successConfig.message === "function"
              ? successConfig.message(payload)
              : successConfig.message;
          const title =
            typeof successConfig.title === "function"
              ? successConfig.title(payload)
              : successConfig.title || "Success";
          notification = createNotification(
            "success",
            message,
            successConfig.hideDuration ?? 3000,
            title,
          );
        }
      }
      if (notification) {
        listenerApi.dispatch(notification);
      }
    },
  });
}
